
const searchIcons = document.querySelectorAll('.search-icon');
const closeIcon = document.querySelector('.close-search');
const searchModal = document.querySelector('.search-modal');

function searchModalToggle() {
    
    (function openSearchModal() {
        Array.prototype.forEach.call(searchIcons, function(el) {
            el.addEventListener('click', function() {
                event.preventDefault();
                searchModal.classList.add('open-search');
                document.querySelector(".search-field").focus(); 
            })
        })
    })();

    (function closeSearchModal() {
        closeIcon.addEventListener('click', function() {
            event.preventDefault();
            searchModal.classList.remove('open-search');
            document.querySelector('.search-icon a').focus(); 
        })
    })(); 
}

searchModalToggle();

export {searchModalToggle}